import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import useEnv from "../../../hooks/env";
import KpiApi from "../../../api/services/KpiApi";
import KpiTile, { EmptyKpiTileProps, KpiTileProps } from "./KpiTile";
import mapKpiTileProps from "./KpiTileProps.mapper";

const THREE_EMPTY_TILES = Array.from(Array(3).keys()).map(
  (index: number): EmptyKpiTileProps => ({
    empty: true,
    key: `empty-${index}`,
  }),
);

function KpiView() {
  const { api } = useEnv();
  const kpiApi = new KpiApi(api);

  const [tileProps, setTileProps] = useState<(KpiTileProps | EmptyKpiTileProps)[]>(THREE_EMPTY_TILES);

  useEffect(() => {
    kpiApi.fetchKpiDashboard().then(mapKpiTileProps).then(setTileProps);
  }, []);

  return (
    <Grid container spacing={3}>
      {tileProps.map((kpiTileProps) => (
        <Grid key={kpiTileProps.key} item xs={12} sm={6} md={4}>
          <KpiTile {...kpiTileProps} />
        </Grid>
      ))}
    </Grid>
  );
}

export default KpiView;
